// src/pages/roles/CastingTestimonials.js

import React, {
  useEffect,
  useState
} from 'react';

import {
  Card,
  Row,
  Col,
  Spinner,
  Alert
} from 'react-bootstrap';

import {
  Star,
  CalendarDays
} from 'lucide-react';

import {
  fetchDirectorTestimonialsApi
} from '../../services/api';

import './CastingTestimonials.css';

const CastingTestimonials = () => {

  const [
    testimonials,
    setTestimonials
  ] = useState([]);

  const [
    loading,
    setLoading
  ] = useState(true);

  const [
    error,
    setError
  ] = useState('');

  useEffect(() => {

    loadTestimonials();

  }, []);

  const loadTestimonials =
  async () => {

    try {

      setLoading(true);

      const res =
      await fetchDirectorTestimonialsApi();

      setTestimonials(
        res.data.data || []
      );

    } catch (err) {

      setError(
        err?.response?.data?.message
        || 'Failed to load reviews'
      );

    } finally {

      setLoading(false);

    }

  };

  if (loading) {

    return (

      <div className="casting-loading">

        <Spinner
          animation="border"
          variant="danger"
        />

      </div>

    );

  }

  return (

    <div className="casting-page">

      <div className="casting-header">

        <h2>

          Casting Director

          <span>
             Reviews
          </span>

        </h2>

        <p>
          Reviews submitted by talents
        </p>
      </div>

      {
        error && (
          <Alert variant="danger">
            {error}
          </Alert>
        )
      }
      <Row>

        {
          testimonials.map((item) => (

            <Col
              xl={3}
              lg={4}
              md={6}
              sm={12}
              className="mb-4 d-flex justify-content-center"
              key={item.id}
            >

              <Card className="casting-card">

                <Card.Body>

                  {/* USER */}

                  <div className="casting-user">

                    <img
                      src={
                        item.user?.profile_image_url
                        ? `${process.env.REACT_APP_API_URL.replace('/api','')}/uploads/${item.user.profile_image_url}`
                        : `https://ui-avatars.com/api/?name=${item.user?.full_name}&background=E50914&color=fff`
                      }
                      alt=""
                      className="casting-user-image"
                    />

                    <div>

                      <h5>
                        {
                          item.user?.full_name
                        }
                      </h5>
                      <p className="casting-role-name">

                      {item.roleName}

                    </p>


                    </div>

                  </div>

                  {/* DIVIDER */}

                  <div className="casting-divider" />

                  {/* STARS */}

                  <div className="casting-stars">

                    {
                      [1,2,3,4,5].map((star) => (

                        <Star
                          key={star}
                          size={18}
                          className={
                            star <= item.rating
                            ? 'casting-star active'
                            : 'casting-star'
                          }
                        />

                      ))
                    }

                  </div>

                  {/* REVIEW */}

                  <p className="casting-review">

                    "
                    {item.review}
                    "

                  </p>

                  {/* DATE */}

                  <div className="casting-date">

                    <CalendarDays size={14} />

                    {
                      new Date(
                        item.created_at
                      ).toLocaleDateString('en-IN', {

                        day: '2-digit',
                        month: 'short',
                        year: 'numeric'

                      })
                    }

                  </div>

                </Card.Body>

              </Card>

            </Col>

          ))
        }

      </Row>

    </div>

  );

};

export default CastingTestimonials;